import set from 'lodash/set';
const unFlatten = (state, separator = '::') => {
    const regex = new RegExp(separator, 'gi');
    const payload = Object.keys(state).reduce((prev, current) => {
        const keyName = current.replace(regex, '.');
        const structuredObj = set(prev, keyName, state[current]);
        return structuredObj;
    }, {});
    return payload;
};
export default unFlatten;
